module.exports = __webpack_public_path__ + "static/fg-texture-91bcf67584f361466d633cc26cf0199a.jpg";